module.exports = __webpack_public_path__ + "src/components/Favorite/triangle.png?3a528607";


//////////////////
// WEBPACK FOOTER
// ./src/components/Favorite/triangle.png
// module id = 2787
// module chunks = 1